import { motion, AnimatePresence } from 'framer-motion';

interface SelectFeedbackProps {
  /** Error message — hat Vorrang vor dem Hilfetext */
  error?: string;
  /** Helper text */
  helperText?: string;
}

/**
 * Hilfetext bzw. Fehlermeldung unterhalb der Auswahl.
 *
 * Es wird immer nur eines von beiden gezeigt: Liegt ein Fehler vor, ersetzt er
 * den Hilfetext. `AnimatePresence` bleibt hier drin, damit der Wechsel
 * zwischen beiden Zustaenden unveraendert ueberblendet.
 */
export const SelectFeedback = ({ error, helperText }: SelectFeedbackProps) => (
  <AnimatePresence mode="wait">
    {error ? (
      <motion.p
        key="error"
        initial={{ opacity: 0, y: -4 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -4 }}
        className="mt-1.5 text-sm text-error flex items-center gap-1"
        role="alert"
      >
        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
        {error}
      </motion.p>
    ) : helperText ? (
      <motion.p
        key="helper"
        initial={{ opacity: 0, y: -4 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -4 }}
        className="mt-1.5 text-sm text-surface-500"
      >
        {helperText}
      </motion.p>
    ) : null}
  </AnimatePresence>
);
